import CollectiveGet from './Get'
import CollectiveDetails from './Details'
import CollectiveGatewayDetails from './GatewayDetails'
import CollectiveActiveGateways from './ActiveGateways';
import CollectiveCreate from './Create';

export {
    CollectiveGet,
    CollectiveDetails,
    CollectiveActiveGateways,
    CollectiveCreate,
    CollectiveGatewayDetails,
}